<script>
import lang from "@/directives/lang";

import Examples from "./Examples.vue";

export default {
  name: "ArticleContentTranslationsExplanations",
  components: {
    Examples
  },
  directives: {
    lang
  },
  props: {
    explanations: {
      type: Array,
      required: true
    }
  }
};
</script>

<template>
  <div>
    <div v-for="(explanation, index) in explanations" :key="index">
      <div
        v-if="explanation.categories || explanation.usages || explanation.explanation"
        class="article-content__text article-content__text--secondary"
      >
        <span v-if="explanation.categories.length > 0" v-lang:da>
          {{ explanation.categories.join(", ")
          }}<span v-if="explanation.usages.length > 0 || explanation.explanation">, </span>
        </span>

        <span v-if="explanation.usages.length > 0" v-lang:da>
          {{ explanation.usages.join(", ") }}<span v-if="explanation.explanation">, </span>
        </span>

        <span v-if="explanation.explanation" v-lang:da>{{ explanation.explanation }}</span>
      </div>

      <Examples :examples="explanation.examples" />
    </div>
  </div>
</template>
